import React, { useContext } from 'react'
import NoteContext from '../context/notes/noteContext'
import asharimg from './asharimg.jpg'
import javascript from './images/javascript.png'
import reactjs from './images/reactjs.png'
import nodejs from './images/nodejs.png'
import mongodb from './images/mongodb.png'
import bootstrap from './images/bootstrap.png'
import cyclic from './images/cyclic.png'
import expressjs from './images/expressjs.png'
import git from './images/git.png'
export default function About() {
    const context = useContext(NoteContext)

    return (
        <div>
      
            <div className="container">
            <h1 className="text-center my-2">A Full Stack Project Powered By</h1>
            <hr />
                <div className="row">
                   
                    <div className=" col-md-4 col-lg-3 col-6 my-4">
                        <img width="150px" src={mongodb} alt="" />

                    </div>
                    <div className=" col-md-4 col-lg-3 col-6 my-4">
                        <img width="150px" src={reactjs} alt="" />

                    </div>
                    <div className=" col-md-4 col-lg-3 col-6 my-4">
                        <img width="150px" src={expressjs} alt="" />

                    </div>
                    <div className=" col-md-4 col-lg-3 col-6 my-4">
                        <img width="150px" src={nodejs} alt="" />

                    </div>
                    <div className=" col-md-4 col-lg-3 col-6 my-4">
                        <img width="150px" src={bootstrap} alt="" />

                    </div>
                    <div className=" col-md-4 col-lg-3 col-6 my-4">
                        <img width="150px" src={cyclic} alt="" />

                    </div>
                    <div className=" col-md-4 col-lg-3 col-6 my-4">
                        <img width="150px" src={javascript} alt="" />

                    </div>
                    <div className=" col-md-4 col-lg-3 col-6 my-4">
                        <img width="150px" src={git} alt="" />

                    </div>
                </div>
                <hr />
                <h1 className="text-center">Developed By</h1>
                <hr />
                <div className="d-flex justify-content-center">
                <img width="200px"  style={{borderRadius:"20px"}} src={asharimg} alt="" />
                </div>
                <h3 className="text-center my-2">Ashar Ahmed</h3>

            </div>
            <hr />
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/about.jsx